export default {"src":"/_next/static/media/plusUiLight_16.ed1d9427.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};